import { css } from "@emotion/react";

export const NewsletterWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const NewsletterContainer = css`
  max-width: 40rem;
`;

export const AlignCenter = css`
  text-align: center;
`;

export const FormContainer = css`
  display: flex;
  gap: 1.2rem;
  justify-content: center;
  align-items: flex-start;
`;

export const MobileFormContainer = css`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const EmailInput = css`
  width: 20rem;
`;
